
import { defineComponent } from 'vue'
import pageHead from '../components/page-head.vue'
import global from '@/utils/global'
import { WorkerDto } from '@/api/dto'
import { addPeport, getSupplierBillConfig, BilConfigItem } from '@/api/report'
import selectPersonnel from '@/views/index/components/select-personnel.vue'
import { fileUpload, hasAppFeature } from '@/api/base'
import { ElUploadRequestOptions } from 'element-plus/lib/components/upload/src/upload.type'
import { ElMessageBox } from 'element-plus'
import AreaSelector from '@/components/AreaSelector.vue'
export default defineComponent({
    name: 'ReportAdd',
    components: {
        AreaSelector,
        'page-head': pageHead,
        'select-personnel': selectPersonnel
    },
    data () {
        return {
            info: {
                employeeId: '',
                employeePhone: '',
                type: '',
                is_serious: '',
                is_hospital: '',
                address: '',
                hospital: '',
                is_public_grade2: '',
                desc: '',
                reporterPhone: '',
                caseDate: '',
                disorder: '',
                client_estimate_money: '',
                area: []
            },
            client_estimate_money_list: [
                '0-1000',
                '1000-3000',
                '3000-5000',
                '5000-10000',
                '10000-20000',
                '20000以上'
            ],
            isAlert: false,
            selection: [] as WorkerDto[],
            token: '',
            files: [] as {
                name: string
                url: string
                preview: string
                id: string
            }[],
            previewFiles: [] as string[],
            previewIndex: 0,
            uploadTitle: '',
            bilConfigList: [] as (BilConfigItem & {
                files: { name: string; url: string; preview: string; id: string }[]
            })[]
        }
    },
    created () {
        if (hasAppFeature('jsbInjuryUploadTitle')) {
            this.uploadTitle = '上传首诊病例/致伤物照片或视频'
        } else {
            this.uploadTitle = '上传伤者受伤图片/视频'
        }
        this.token = global.token
    },
    methods: {
        hasAppFeature,
        // 选择省市区
        handleAreaChange (area : []) {
            this.info.area = area
        },
        onPublicGrade2Change (val: string | number | boolean) {
            if (String(val) === '0') {
                ElMessageBox.alert(
                    '该方案需二级及以上公立医院就诊，请及时转院治疗，请确认已知晓',
                    '提示',
                    {
                        confirmButtonText: '我已知晓'
                    }
                ).catch(() => undefined)
            }
        },
        async submit () {
            if (!this.selection.length) {
                this.$message.error('请选择出险人')
                return
            }
            if (!this.files.length) {
                this.$message.error(this.uploadTitle)
                return
            }
            if (!/^1\d{10}$/.test(this.info.employeePhone)) {
                this.$message.error('请输入11位出险人联系电话')
                return
            }
            if (!/^1\d{10}$/.test(this.info.reporterPhone)) {
                this.$message.error('请输入11位报案人联系电话')
                return
            }
            if (!this.info.caseDate) {
                this.$message.error('请选择出险时间')
                return
            }
            if (this.info.area.length < 1) {
                this.$message.error('请选择出险省市区')
                return
            }
            if (!this.info.address) {
                this.$message.error('请输入出险地点')
                return
            }
            if (!this.info.desc) {
                this.$message.error('请输入详细事故经过')
                return
            }
            if (!this.info.type) {
                this.$message.error('请选择事故类型')
                return
            }
            if (this.info.is_serious === '') {
                this.$message.error('请选择是否骨折')
                return
            }
            if (this.info.is_hospital === '') {
                this.$message.error('请选择是否住院')
                return
            }
            if (hasAppFeature('publicGrade2Hospital') && this.info.hospital && this.info.is_public_grade2 === '') {
                this.$message.error('请选择医院是否公立二级以上')
                return
            }
            const fileIds = this.files.map(item => item.id)

            if (this.info.disorder === '' && hasAppFeature('lgdCaseExtra')) {
                this.$message.error('请输入诊断结果')
                return
            }

            if (this.info.client_estimate_money === '' && hasAppFeature('lgdCaseExtra')) {
                this.$message.error('请选择预估金额')
                return
            }

            if (this.files.map(item => item.id).length === 0) {
                this.$message.error('上传伤者受伤图片/视频')
                return
            }
            for (const configItem of this.bilConfigList) {
                if (configItem.is_required === 1 && configItem.files.length === 0) {
                    this.$message.error(`请上传${configItem.type}`)
                    return
                }
            }
            const billList: { file_id: string; type: string }[] = []
            this.bilConfigList.forEach(configItem => {
                configItem.files.forEach(file => {
                    billList.push({ file_id: file.id, type: configItem.type })
                })
            })
            await addPeport({
                ...this.info,
                employeeId: this.selection[0].employee_id,
                fileIds: fileIds,
                billFileIds: billList
            })
            console.log("this.$message.success('申报成功！')")
            this.$message.success('申报成功，正在为您跳转到列表页！')
            this.$router.push({
                path: '/report'
            })
        },
        // 上传视频
        async fileUpload (file: ElUploadRequestOptions) {
            const FormDatas = new FormData()
            FormDatas.append('iFile', file.file)
            const data = await fileUpload(FormDatas, {
                isLoading: false,
                onUploadProgress: (progressEvent: {
                    loaded: number
                    total: number
                }) => {
                    const num =
                        ((progressEvent.loaded / progressEvent.total) * 100) | 0 // 百分比
                    file.onProgress(({
                        percent: num
                    } as unknown) as ProgressEvent) // 进度条
                    if (num === 100) {
                        file.onSuccess('arraybuffer')
                    }
                }
            })
            this.files.push({
                name: data.fileInfo.file_name,
                url: data.fileInfo.external_url,
                preview: data.fileInfo.preview_url,
                id: data.fileInfo.file_id
            })
            console.log(data)
        },
        filePreview (file: { preview: string; name: string }) {
            if (/(jpg)|(png)|(gif)|(jpeg)|(bmp)|(webp)/.test(file.name)) {
                this.previewFiles = [file.preview]
            } else {
                window.location.href = file.preview
            }
        },
        fileRemove (file: { id: string }) {
            console.log(file)
            this.files.forEach(item => {
                if (item.id === file.id) {
                    const index = this.files.indexOf(item)
                    this.files.splice(index, 1)
                }
            })
        },
        fileLimit (file: File) {
            if (file.size / 1024 / 1024 > 20) {
                this.$message.error('请限制视频大小在20M以内')
                throw new Error('请限制视频大小在20M以内')
            }
        },
        isEject () {
            this.isAlert = true
        },
        // 关闭
        close () {
            this.isAlert = false
        },
        async confirm (arr: WorkerDto[]) {
            this.isAlert = false
            this.selection = arr
            this.bilConfigList = []
            if (arr.length > 0) {
                await this.fetchBilConfig(arr[0].policy_id)
            }
        },
        async fetchBilConfig (policyId: number) {
            try {
                const res = await getSupplierBillConfig({ policyId })
                const list = Array.isArray(res) ? res : []
                this.bilConfigList = list
                    .filter(item => item.is_frist_required === 1)
                    .map(item => ({ ...item, files: [] }))
            } catch (e) {
                this.bilConfigList = []
            }
        },
        async billFileUpload (file: ElUploadRequestOptions, configIndex: number) {
            const FormDatas = new FormData()
            FormDatas.append('iFile', file.file)
            const data = await fileUpload(FormDatas, {
                isLoading: false,
                onUploadProgress: (progressEvent: {
                    loaded: number
                    total: number
                }) => {
                    const num =
                        ((progressEvent.loaded / progressEvent.total) * 100) | 0
                    file.onProgress(({
                        percent: num
                    } as unknown) as ProgressEvent)
                    if (num === 100) {
                        file.onSuccess('arraybuffer')
                    }
                }
            })
            this.bilConfigList[configIndex].files.push({
                name: data.fileInfo.file_name,
                url: data.fileInfo.external_url,
                preview: data.fileInfo.preview_url,
                id: data.fileInfo.file_id
            })
        },
        billFileRemove (file: { id: string }, configIndex: number) {
            const files = this.bilConfigList[configIndex].files
            const index = files.findIndex(item => item.id === file.id)
            if (index !== -1) {
                files.splice(index, 1)
            }
        }
    }
})
